import React from 'react';
import { Box, Typography } from '@mui/material';
import * as styles from './styles';

const LINKS = [
    { label: 'About Us',       href: 'https://ecal.com/about-us/' },
    { label: 'Careers',        href: 'https://ecal.com/about-us/#careers' },
    { label: 'Contact Us',     href: 'https://ecal.com/contact-us/' },
    { label: 'Support Centre', href: 'https://support.ecal.com/' },
];

function Company() {
    return (
        <Box>
            <Typography sx={styles.colTitle}>Company</Typography>
            <Box component="ul" sx={styles.linkList}>
                {LINKS.map(({ label, href }) => (
                    <li key={href}>
                        <Box
                            component="a"
                            href={href}
                            target="_blank"
                            rel="noreferrer noopener"
                            sx={styles.link}
                        >
                            {label}
                        </Box>
                    </li>
                ))}
            </Box>
        </Box>
    );
}

export default Company;
